import React from 'react';
import block from 'bem-cn-lite';

const b = block('RequestFormsHeader');

export default ({name, description}) => <div className={b()}>
    <h3 className={b('name')}>{name}</h3>
    <div className={b('description')}>
        {description}
    </div>
</div>